import { IGenericLabelValue } from '@shared/interface/generic';
import { IDistributorArea } from '@pages/distributor/interfaces/distributor.interface';
import { IDistributorOption, IProductRewardProgramMarketing } from '@pages/sales-marketing/program-marketing-legacy/program-marketing-legacy.interface';
import { IProgramRewardProduct } from '@pages/sales-marketing/program-marketing/program-marketing-retailer/program-marketing-retailer.interface';
import {
  IProductBonusProgramMarketing
} from '@pages/sales-marketing/program-marketing/program-marketing-distributor/program-marketing-distributor-interface';

export class IInputSelectOptions implements IGenericLabelValue {
  label: string;
  value: string;
  disabled: boolean;
  description: string;
}

export class IInputSelectOptionsDistributor extends IInputSelectOptions {
  area: string;
  code: string;
}

export class IInputSelectOptionsProductBonus extends IInputSelectOptions {
  brand_id: string;
  sale_unit: string;
  weight_unit: string;
}

export class ISelectDistributorArea extends IInputSelectOptions {
  setSelector(_selector: IDistributorArea) {
    const { id, name, user } = _selector;
    let _label = name;
    _label += user ? ', ' + user : ', -';
    this.value = id;
    this.label = _label;
  }
}

export class ISelectProductReward extends IInputSelectOptions {
  setSelector(_selector: IProductRewardProgramMarketing) {
    const { variant_id, variant_name } = _selector;
    this.value = variant_id;
    this.label = variant_name;
  }
}

export class ISelectProductBonus extends IInputSelectOptionsProductBonus {
  setSelector(_selector: IProductBonusProgramMarketing) {
    const { id, name, brand_id, sale_unit, weight_unit } = _selector;
    this.value = id;
    this.label = name;
    this.brand_id = brand_id;
    this.sale_unit = sale_unit;
    this.weight_unit = weight_unit;
  }
}

export class ISelectProgramRewardProduct extends IInputSelectOptions implements IProgramRewardProduct {
  variant_id: string;
  variant_name: string;
  sale_unit: string;
  price_unit: number;

  setSelector(_selector: IProgramRewardProduct) {
    const { variant_id, variant_name } = _selector;
    this.value = variant_id;
    this.label = variant_name;
  }
}

export class ISelectDistributorProgramMarketing extends IInputSelectOptionsDistributor {
  setSelector(_selector: IDistributorOption) {
    const { name, id, code } = _selector;
    this.value = id;
    this.label = code + ', ' + name;
  }
}
